import { render, staticRenderFns } from "./select-list.vue?vue&type=template&id=1843461f&scoped=true"
import script from "./select-list.vue?vue&type=script&lang=js"
export * from "./select-list.vue?vue&type=script&lang=js"
import style0 from "./select-list.vue?vue&type=style&index=0&id=1843461f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1843461f",
  null
  
)

export default component.exports